import React, { useState, useEffect, Suspense } from 'react';
import { BounceLoader } from 'react-spinners';

const fetchTopPlayers = () => {
  return new Promise((resolve) => {
      fetch('https://surfapi.insanitygaming.net/api/runner?limit=25&order=1', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`API error: ${response.status} ${response.statusText}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.status === 200) {
            resolve(data.users);
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          resolve([]); // Resolve with empty data if there's an error
        });
  });
};

const TopPlayersList = () => {
  const [topPlayers, setTopPlayers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const playersPerPage = 10;

  useEffect(() => {
    fetchTopPlayers().then((data) => {
      setTopPlayers(data);
    });
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(topPlayers.length / playersPerPage);
  const currentPageData = topPlayers.slice(
    (currentPage - 1) * playersPerPage,
    currentPage * playersPerPage
  );

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <section className="p-4 bg-gray-800 shadow rounded-lg h-full flex flex-col">
      <h4 className="font-bold mb-2 text-gray-200">Top Record Holders</h4>
      <div className="overflow-y-auto flex-grow">
	  <table className="min-w-full table-auto text-left text-gray-300">
  <thead>
    <tr>
      <th className="px-4 py-2 border-b h-12">Rank</th>
      <th className="px-4 py-2 border-b h-12">Name</th>
      <th className="px-4 py-2 border-b h-12">Records</th>
    </tr>
  </thead>
  <tbody>
    {currentPageData.map((player, idx) => (
      <tr key={player.user_id} className="h-12">
        <td className="px-4 py-2 border-b h-12">{((currentPage - 1) * 10) + idx + 1}</td>
        <td
          className="px-4 py-2 border-b h-12 whitespace-nowrap overflow-hidden text-ellipsis max-w-[150px]"
          title={player.name} // Show full name on hover
        >
          {player.name}
        </td>
        <td
          className="px-4 py-2 border-b h-12 whitespace-nowrap overflow-hidden text-ellipsis max-w-[150px]">{player.records}</td>
      </tr>
    ))}
  </tbody>
</table>
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center mt-4">
        <button
          className={`px-4 py-2 mx-1 rounded-md ${
            currentPage === 1 ? 'bg-gray-600 text-gray-400' : 'bg-gray-700 text-white hover:bg-gray-600'
          }`}
          disabled={currentPage === 1}
          onClick={handlePrev}
        >
          Prev
        </button>
        <span className="px-4 py-2 text-gray-300">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={`px-4 py-2 mx-1 rounded-md ${
            currentPage === totalPages ? 'bg-gray-600 text-gray-400' : 'bg-gray-700 text-white hover:bg-gray-600'
          }`}
          disabled={currentPage === totalPages}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </section>
  );
};

const TopRecordHolders = () => {
  return (
    <Suspense
      fallback={
        <div className="absolute inset-0 flex justify-center items-center bg-gray-800 bg-opacity-75 z-10">
          <BounceLoader size={50} color="#4CAF50" />
        </div>
      }
    >
      <TopPlayersList />
    </Suspense>
  );
};

export default TopRecordHolders;
